import { useState, useEffect, useCallback } from "react";
import Header from "../common/header";
import CommonCard from "../common/commonCard";
import FormCard from "../common/formCard";
import { Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PopUpPublicIncident from "../specific/popUpPublicIncident";
import CheckBox from "../common/customCheckBox";
import { FaTimes } from "react-icons/fa";
// import { GetComapanyService } from "../../Services/companyService";
import { GetComapanyServiceReduced } from "../../Services/companyService";
import { GetIncidentCategoriesService } from "../../Services/incidentCategoryService";
import { PostIncidentService } from "../../Services/incidentService";
import { useParams } from "react-router-dom";
import { getFileInformation } from "../../utils/base64Conver";
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from "react-i18next";
import { GetCustomQuestionsIncidentService } from "../../Services/customQuestionsService";
import { FaCircleInfo, FaDatabase } from "react-icons/fa6";
import MessagePopUp from "../common/messagePopUp";
import AudioRecorder from "../common/audioRecorder";

const CreateIncident = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalStep, setModalStep] = useState(1);
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [audio, setAudio] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [workPlacesData, setWorkPlacesData] = useState(null);
  const [incidentCategoryData, setIncidentCategory] = useState(null);
  const [customQuestions, setCustomQuestions] = useState(null);
  const [loadingData, setLoadingData] = useState(false);
  const [t] = useTranslation("publicIncident")
  const [tIncidents] = useTranslation("incidents")

  const [audioWarningPopUp, setAudioWarningPopUp] = useState(false)
  const [showAudioRecord, setShowAudioRecord] = useState(false)




  const { id } = useParams();
  const [key, setKey] = useState(null);
  const [pdfData, setPdfData] = useState({
    companyImage: "",
    id: "",
    key: "",
  });


  const [isFormValid, setIsFormValid] = useState(false);
  const [formData, setFormData] = useState({
    incidentType: "",
    category: "",
    name: "",
    title: "",
    description: "",
    acceptCheck: "",
    file: "",
    audio: "",
    // responsible: "",
    // responsibleKey: "",
    workPlace: "",
    company: "",
    mail: "",
    informantType: "",
    incidentDate: '',
  });

  const [fieldErrors, setFieldErrors] = useState({});

  async function getCompany() {
    setLoadingData(true)
    try {
      const companyData = await GetComapanyServiceReduced(id);
      // const workplacesData = await GetWorkPlacesFromCompanyServiceFiltered(id);
      const formattedWorkPlacesData = companyData.workplaces.map(workplace => {
        return {
          value: workplace.workplaceId,
          label: workplace.workplaceName
        };
      });

      setCompanyData(companyData);
      setWorkPlacesData(formattedWorkPlacesData)
      pdfData.companyImage = companyData.imageData;
      pdfData.id = id;
      pdfData.publicLink = companyData.publicLink
      setLoadingData(false)
    } catch (error) {
      console.error(error);
      setLoadingData(false)
    }
  };

  async function getCustomQuestions() {
    setLoadingData(true)
    try {
      const customQuestions = await GetCustomQuestionsIncidentService(id);
      setCustomQuestions(customQuestions)
      setLoadingData(false)
    } catch (error) {
      console.error(error);
      setLoadingData(false)
    }
  };

  async function getCategories() {
    const incidentCategoryData = await GetIncidentCategoriesService(id);
    setIncidentCategory(incidentCategoryData);
  }


  function reloadAllData() {
    getCategories()
    getCompany();
    getCustomQuestions();
  }

  //LLAMADAS API
  useEffect(() => {
    reloadAllData()
  }, [id]); // Se ejecutará cada vez que `id` cambie

  useEffect(() => {

    if (companyData && !companyData.enabled) {

      const fullURL = window.location.href;
      navigate(`/access-denied`, { state: { companyData, fullURL } });

    }
  }, [companyData]);


  useEffect(() => {
  }, [incidentCategoryData]);




  useEffect(() => {
    const allFieldsValid = Object.values(fieldErrors).every((error) => !error);
    setIsFormValid(allFieldsValid);
  }, [fieldErrors]);


  useEffect(() => {
    if (formData.incidentType) {
      formData.name = '';
      validateField('name', '')
    }
  }, [formData]);

  const validateField = (field, value, workplaces = workPlacesData) => {
    let isError = false;
    let errorMessage = null;

    switch (field) {
      case "incidentType":
        isError = value === "";
        errorMessage = isError ? `${t("createForm.error")}` : null;
        break;
      case "category":
        isError = value === "";
        errorMessage = isError ? `${t("createForm.error")}` : null;
        break;

      case "workPlace":
        isError = workplaces.length > 0 ? value === "" : false;
        errorMessage = isError ? `${t("createForm.error")}` : null;
        break;

      case "name":
        /*  const validName = /^[a-zA-ZÀ-ÿ\s\-']+$/u; */
        isError = formData.incidentType ? false : value === "" || value.length > 100;
        errorMessage = isError ? `${t("createForm.nameError")}` : null;
        break;
      case "title":
        if (value === "") {
          isError = true;
          errorMessage = `${t("createForm.error")}`;
        } else if (value.length > 100) {
          isError = true;
          errorMessage = `${t("createForm.titleErrorLength")}`;
        }
        break;
      case "description":
        if (value === "") {
          isError = true;
          errorMessage = isError ? `${t("createForm.error")}` : null;
        } else if (value.length > 500) {
          isError = true;
          errorMessage = `${t("createForm.descriptionErrorLength")}`;
        }
        break;
      case "acceptCheck":
        isError = value === "" || value === false;
        errorMessage = isError ? `${t("createForm.error")}` : null;
        break;
      case "incidentDate":
        isError = !value || value === "";
        errorMessage = isError ? `${t("createForm.error")}` : null;
        break;

      default:
        if (value === "" || !value) {
          isError = true;
          errorMessage = isError ? `${t("createForm.error")}` : null;
        } else if (value.length > 100) {
          isError = true;
          errorMessage = `${t("createForm.errorLength100")}`;
        }
        break;
    }

    setFieldErrors((prevFieldErrors) => {
      const newErrors = { ...prevFieldErrors, [field]: isError };
      newErrors[`${field}Message`] = errorMessage;
      return newErrors;
    });
    return !isError
  };


  const validateAllFields = () => {

    const { incidentType, category, acceptCheck, name, title, description, informantType, incidentDate, workPlace } = formData;


    const isIncidentTypeValid = validateField("incidentType", incidentType);

    const isCategoryValid = validateField("category", category);

    const isAcceptCheckValid = validateField("acceptCheck", acceptCheck);

    const isNameValid = !incidentType ? validateField("name", name) : true;

    const isTitleValid = validateField("title", title);

    const isDescriptionValid = validateField("description", description);

    const isWorkPacesValid = validateField("workPlace", workPlace);

    // const isIncidentDateValid = validateField("incidentDate", formData.incidentDate);

    let allCustomQuestionsValid = true;


    customQuestions.forEach(question => {

      const fieldName = question?.customQuestion;

      if (formData.customResponse) {
        const fieldNameId = formData.customResponse.customQuestion.findIndex(id => id === fieldName);
        const fieldValue = formData.customResponse.response[fieldNameId]
        const isValid = validateField(fieldName, fieldValue);
        if (!isValid) {
          allCustomQuestionsValid = false;
        }
      } else {
        validateField(fieldName, null)
        allCustomQuestionsValid = false;
      }


    });

    return isIncidentTypeValid && isCategoryValid && isCategoryValid && isAcceptCheckValid && isNameValid && isTitleValid && isDescriptionValid && isWorkPacesValid && allCustomQuestionsValid;
  }


  const handleFileInput = async (e) => {
    const fileData = e.target.files[0];

    if (!fileData) return; // Si no hay archivo, salir de la función

    const maxSize = 2 * 1024 * 1024; // 2 MB
    const valid_mimetypes = [
      'application/pdf',
      'image/jpeg',
      'image/png',
      'application/msword',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',      // .xlsx
      'application/x-rar-compressed',
      'application/zip',
      'video/x-matroska',
      'video/mp4',
      'audio/mpeg'
    ];



    if (fileData.size > maxSize) {
      setFileError(`${t("createForm.fileSizeError")}`);
      setFile(null);
      return;
    }


    if (!valid_mimetypes.includes(fileData.type)) {
      setFileError(`${t("createForm.fileTypeError")} .zip, .rar, .doc, .xls, .pdf, .jpg, .png, .mp3, .mkv, .mp4`);
      setFile(null);
      return;
    }

    const fileConvert = await getFileInformation(fileData);

    setFile(fileConvert);
    setFileError(null);
  };


  const handleCancelClick = () => {
    navigate(`/public/${id}`); // Navega a la página /createIncident
  };

  const handleFieldChange = (field, value) => {
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, [field]: value };
      validateField(field, value); // Validar el campo cuando se actualiza
      return updatedFormData;
    });
  };

  const handleCustomFieldChange = (field, value) => {
    setFormData((prevFormData) => {
      const index = prevFormData.customResponse?.customQuestion?.indexOf(field);
      let newResponse, newQuestion;

      if (index >= 0) {
        // El campo ya existe, sobrescribe el valor correspondiente
        newResponse = [...prevFormData.customResponse.response];
        newResponse[index] = value;
        newQuestion = [...prevFormData.customResponse.customQuestion];
      } else {
        // El campo no existe, agrega un nuevo elemento
        newResponse = prevFormData.customResponse?.response ? [...prevFormData.customResponse.response, value] : [value];
        newQuestion = prevFormData.customResponse?.customQuestion ? [...prevFormData.customResponse.customQuestion, field] : [field];
      }

      const updatedFormData = {
        ...prevFormData,
        customResponse: {
          ...prevFormData.customResponse,
          response: newResponse,
          customQuestion: newQuestion
        }
      };
      validateField(field, value); // Validar el campo cuando se actualiza
      return updatedFormData;
    });
  };


  const handleSaveClick = () => {
    if (validateAllFields()) {
      // formData.responsible = companyData.responsible;
      // formData.responsibleKey = companyData.responsibleKey
      formData.company = id;
      formData.file = file;
      formData.audio = audio;
      setShowModal(true)
    }
  };

  const handleInputChange = useCallback((inputValue) => {
    setFormData((prev) => ({
      ...prev,
      mail: inputValue,
    }));
  }, []);

  const handleShowAudioRecord = () => {
    setShowAudioRecord(true);
    setAudioWarningPopUp(false)
  }


  const handleAudioRecordChanged = async (e) => {
    const blobUrl = e; // URL que recibes
    try {
      const response = await fetch(blobUrl); // Obtener el Blob desde la URL
      const blob = await response.blob(); // Convertir la respuesta en un Blob

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Audio = reader.result;
        setAudio(base64Audio); // Guardar el audio en base64 en el estado
      };
      reader.readAsDataURL(blob); // Iniciar la lectura del Blob como Data URL (Base64)
    } catch (error) {
      console.error("Error al convertir Blob a Base64:", error);
    }
  };





  const handleCreateClick = async (e) => {
    setLoading(true)

    e.preventDefault(); // Anula el comportamiento predeterminado de envío del formulario.
    // Haz lo que tengas que hacer, luego:
    const response = await PostIncidentService(formData);
    setKey(response.userKey);
    pdfData.key = response.userKey;
    setModalStep(2); // Avanzar al siguiente paso
    setLoading(false)

  };

  const handleContinueClick = (e) => {
    e.preventDefault(); // Anula el comportamiento predeterminado de envío del formulario.
    navigate(`/public/${id}`);
  };

  const resetModal = () => {
    setModalStep(1); // Reiniciar al paso 1
    setShowModal(false); // Cerrar el modal
  };



  const removeFile = () => {
    setFile(null);
  };

  return (
    <div>
      <MessagePopUp
        show={audioWarningPopUp}
        handleClose={() => setAudioWarningPopUp(false)}
        title={t("audioWarnigPopUp.messageAudioCreationTitle")}
        textBody={t("audioWarnigPopUp.messageAudioCreationText")}
        buttonText={t("audioWarnigPopUp.acceptButton")}
        cancelButtonText={t("audioWarnigPopUp.cancelButton")}
        onClickButton={handleShowAudioRecord}
        onClickCancelButton={() => setAudioWarningPopUp(false)}
      />
      <Header privateWeb={true} publicIncident={true} imageMimeType={companyData && companyData.imageMimeType}
        imageData={companyData && companyData.imageData} reloadData={reloadAllData} companyId={companyData && companyData.companyId} showUpdate={false} />
      <div style={{ width: "90%", margin: "0 auto" }}>
        <CommonCard title={tIncidents("createCard.title")} icon={'FaPlus'}>
          {loadingData ?
            <div className="create-incident-loading-container">
              <div className="public-card-loading-row ">
                <div className="public-card-loading-popup custom-shadow-bold rounded-border-px">
                  <Spinner animation="border" className="spinner-bigger" />
                </div>
              </div>
            </div>
            :
            <>
              <div className="clean-card-title"><FaDatabase size={18} />{t("createForm.incidentDataTitle")}</div>

              <Row>
                <Col md={6}>
                  <FormCard
                    title={t("createForm.incidentType")}
                    type={"select"}
                    readOnly={false}
                    error={fieldErrors.incidentType}
                    errorMessage={fieldErrors.incidentTypeMessage}
                    onChange={(e) => handleFieldChange("incidentType", e.value)}
                    options={[
                      { label: "---", value: "" },
                      { label: `${t("createForm.anonymous")}`, value: true },
                      { label: `${t("createForm.confidential")}`, value: false },
                    ]}
                  />
                </Col>
                <Col md={6}>
                  <FormCard
                    title={t("createForm.category")}
                    type={"select"}
                    readOnly={false}
                    error={fieldErrors.category}
                    errorMessage={fieldErrors.categoryMessage}
                    onChange={(e) => handleFieldChange("category", e.value)}
                    options={incidentCategoryData ? incidentCategoryData : [
                      { label: "---", value: "" },]}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  {formData.incidentType !== "" ? (
                    <div>
                      <CheckBox
                        text={
                          formData.incidentType
                            ? `${t("createForm.acceptCheckAnonymous")}`
                            : !formData.incidentType
                              ? `${t("createForm.acceptCheckConfidential")}`
                              : ""
                        }
                        error={fieldErrors.acceptCheck}
                        errorMessage={fieldErrors.acceptCheckMessage}
                        onChange={(e) => handleFieldChange("acceptCheck", e)}
                        bigCheck
                      />
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormCard
                    title={t("createForm.informantType")}
                    type={"select"}
                    readOnly={false}
                    error={fieldErrors.informantType}
                    errorMessage={fieldErrors.informantTypeMessage}
                    onChange={(e) => handleFieldChange("informantType", e.value)}
                    options={[
                      { label: "---", value: "" },
                      { label: `${t("createForm.incidentTypeEmployee")}`, value: 'Empleado' },
                      { label: `${t("createForm.incidentTypeCustomer")}`, value: 'Cliente' },
                      { label: `${t("createForm.incidentTypeProvider")}`, value: 'Proveedor' },
                      { label: `${t("createForm.incidentTypeOther")}`, value: 'Otros' }

                    ]}
                  />
                </Col>
                <Col md={6}>
                  {!formData.incidentType ?
                    <FormCard
                      key={0}
                      title={t("createForm.name")}
                      type={"text"}
                      readOnly={formData.incidentType ? true : false}
                      error={fieldErrors.name}
                      errorMessage={fieldErrors.nameMessage}
                      onChange={(e) => handleFieldChange("name", e.target.value)}
                    />
                    :
                    <FormCard
                      key={1}
                      title={t("createForm.name")}
                      type={"text"}
                      readOnly={formData.incidentType ? true : false}
                    />

                  }
                </Col>
              </Row>
              <Row>
                {workPlacesData && workPlacesData.length > 0
                  ?
                  <Col md={6}>
                    <FormCard
                      title={t("createForm.workPlace")}
                      type={"select"}
                      readOnly={false}
                      error={fieldErrors.workPlace}
                      errorMessage={fieldErrors.workPlaceMessage}
                      onChange={(e) => handleFieldChange("workPlace", e.value)}
                      options={workPlacesData}
                    />
                  </Col>
                  :
                  null
                }

              </Row>
              <div className="clean-card-title mt-4"><FaCircleInfo size={18} />{t("createForm.incidentInfoTitle")}</div>

              <Row>
                <Col md={6}>
                  <FormCard
                    title={t("createForm.title")}
                    type={"text"}
                    readOnly={false}
                    error={fieldErrors.title}
                    errorMessage={fieldErrors.titleMessage}
                    onChange={(e) => handleFieldChange("title", e.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <FormCard
                    title={t("createForm.incidentDate")}
                    type={"date"}
                    maxToday={true}
                    readOnly={false}
                    error={fieldErrors.incidentDate}
                    errorMessage={fieldErrors.incidentDateMessage}
                    onChange={(e) => handleFieldChange("incidentDate", e.target.value)}
                  />
                </Col>
              </Row>
              {
                customQuestions &&
                customQuestions.reduce((result, question, index) => {
                  if (index % 2 === 0) {
                    result.push([question]);
                  } else {
                    result[result.length - 1].push(question);
                  }
                  return result;
                }, []).map((questionPair, index) => (
                  <Row key={index}>
                    {questionPair.map((question, idx) => (
                      <Col md={6} key={idx}>
                        <FormCard
                          key={question.customQuestion}
                          title={question.title}
                          type={"text"}
                          readOnly={false}
                          error={fieldErrors[question.customQuestion]}
                          errorMessage={fieldErrors[`${question.customQuestion}Message`]}
                          onChange={(e) => handleCustomFieldChange(question.customQuestion, e.target.value)}
                        />
                      </Col>
                    ))}
                  </Row>
                ))
              }
              <Row>
                <Col md={6}>
                  <FormCard
                    title={t("createForm.description")}
                    type={"textarea"}
                    readOnly={false}
                    error={fieldErrors.description}
                    errorMessage={fieldErrors.descriptionMessage}
                    onChange={(e) => handleFieldChange("description", e.target.value)}
                  />
                </Col>
                <Col
                  md={3}
                  style={{ height: "100%" }}
                  className="d-flex flex-column align-items-center mt-5"
                >
                  {file && (
                    <div className="mb-4 add-doc custom-shadow">
                      {" "}
                      <span>{file.fileName}</span>
                      <FaTimes className="add-doc-icon" onClick={removeFile} />
                    </div>
                  )}
                  {fileError && (
                    <span className="form-card-input-error-text m-auto text-center">{fileError}</span>
                  )}
                  <input
                    type="file"
                    id="fileInput"
                    style={{ display: "none" }}
                    onChange={handleFileInput}
                  />
                  <label htmlFor="fileInput">
                    <Button variant="secondary" className="custom-button-secondary" as="span">
                      {t("createForm.addDoc")}
                    </Button>
                  </label>
                </Col>
                <Col
                  md={3}
                  style={{ height: "100%" }}
                  className="d-flex flex-column align-items-center mt-5"
                >
                  {!showAudioRecord
                    ?
                    <Button variant="secondary" className="custom-button-secondary" onClick={() => setAudioWarningPopUp(true)}>
                      {t("createForm.addAudio")}
                    </Button>
                    :
                    <AudioRecorder onAudioChange={handleAudioRecordChanged} />
                  }

                </Col>
              </Row>
              <div className="d-flex justify-content-around mt-4">
                <Button variant="secondary" className="custom-button-secondary" onClick={handleCancelClick}>
                  {t("createForm.cancel")}
                </Button>
                <Button
                  variant="success"
                  className="custom-button-primary"
                  onClick={handleSaveClick}
                  disabled={!isFormValid}
                >
                  {t("createForm.save")}
                </Button>
              </div>
            </>
          }



        </CommonCard>
        {showModal && (
          <PopUpPublicIncident
            show={showModal}
            handleClose={resetModal} // Cierra y reinicia el modal
            modalStep={modalStep}
            title={modalStep === 1 ? `${t("createForm.createIncident")}` : `${t("createForm.incidentCreated")}`}
            buttonText={modalStep === 1 ? `${t("createForm.create")}` : `${t("createForm.continue")}`}
            label={modalStep === 1 ? `${t("createForm.mail")}` : `${t("createForm.key")}`}
            text={
              modalStep === 1
                ? `${t("createForm.notificationsMail")}`
                : `${t("createForm.saveCodeTitle")}`
            }
            checkBox={
              modalStep === 1
                ? `${t("createForm.disableNotifications")}`
                : `${t("createForm.saveCode")}`
            }
            value={
              modalStep === 1 ? null : key ? key : `${t("createForm.loading")}`
            }
            readonly={modalStep === 1 ? false : true}
            copyClipBoard={modalStep === 1 ? false : true}
            validationType={
              modalStep === 1 ? "email_and_checkbox" : "only_checkbox"
            }
            download={modalStep === 1 ? false : true}
            closeButton={modalStep === 1 ? false : true}
            onSubmit={modalStep === 1 ? handleCreateClick : handleContinueClick}
            onInputChange={modalStep === 1 ? handleInputChange : null}
            pdfData={pdfData}
            loading={loading}
          />
        )}
      </div>
    </div>
  );
};

export default CreateIncident;
